module.exports = __webpack_public_path__ + "media/images/apple_health/watch/akt-7c7bb397519698378e388dc38b0c3563.svg";